import { render, staticRenderFns } from "./StoreRegister.vue?vue&type=template&id=5d5919ad&"
import script from "./StoreRegister.vue?vue&type=script&lang=js&"
export * from "./StoreRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports